import styled from "styled-components";

const AdminSectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;

  span {
    font-weight: 950;
    color: #fff9ea;
  }
`;

export default AdminSectionTitle;
